var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "basura Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Editar-producto",
    transform: "translate(-770.000000, -1271.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "basura-Copy",
    transform: "translate(770.000000, 1271.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#9F9F9F"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.687500, 0.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2187516,2.25 L10.1250008,2.25 L10.1250008,1.6875 C10.1250008,0.757019556 9.3679815,0 8.43750091,0 L6.18750052,0 C5.25702037,0 4.5,0.757019556 4.5,1.6875 L4.5,2.25 L1.40625015,2.25 C0.630843861,2.25 0,2.88084384 0,3.65625 L0,5.625 C0,5.9356404 0.251859453,6.1875 0.562500061,6.1875 L0.869906467,6.1875 L1.35587127,16.3927613 C1.39879705,17.2940265 2.13918764,18 3.04143758,18 L11.583563,18 C12.4858489,18 13.2262388,17.2940274 13.2691303,16.3927613 L13.7550942,6.1875 L14.0625005,6.1875 C14.3731409,6.1875 14.625001,5.9356404 14.625001,5.625 L14.625001,3.65625 C14.625001,2.88084384 13.9941574,2.25 13.2187501,2.25 L13.2187516,2.25 Z M5.625,1.6875 C5.625,1.37735161 5.87735139,1.125 6.18750009,1.125 L8.43750064,1.125 C8.74764868,1.125 9.0000005,1.37735161 9.0000005,1.6875 L9.0000005,2.25 L5.625,2.25 L5.625,1.6875 Z M1.125,3.65625009 C1.125,3.50117571 1.25117571,3.375 1.40625009,3.375 L13.2187542,3.375 C13.3738285,3.375 13.500004,3.50117571 13.500004,3.65625009 L13.500004,5.0625005 C13.3266488,5.0625005 1.84334841,5.0625005 1.125,5.0625005 L1.125,3.65625009 Z M12.1453194,16.3392562 C12.1310099,16.639667 11.8842133,16.875003 11.5834869,16.875003 L3.04135978,16.875003 C2.74059794,16.875003 2.49380118,16.639667 2.47952752,16.3392562 L1.9960938,6.1875 L12.6287528,6.1875 L12.1453194,16.3392562 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3125,15.75 C7.62314057,15.75 7.875,15.498141 7.875,15.1875006 L7.875,7.87500003 C7.875,7.56435944 7.62314057,7.3125 7.3125,7.3125 C7.00185943,7.3125 6.75,7.56435944 6.75,7.87500003 L6.75,15.1875006 C6.75,15.498141 7.00182402,15.75 7.3125,15.75 L7.3125,15.75 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125,15.75 C10.4356406,15.75 10.6875,15.498141 10.6875,15.1875006 L10.6875,7.87500003 C10.6875,7.56435944 10.4356406,7.3125 10.125,7.3125 C9.81435943,7.3125 9.5625,7.56435944 9.5625,7.87500003 L9.5625,15.1875006 C9.5625,15.498141 9.81432402,15.75 10.125,15.75 L10.125,15.75 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49999975,15.75 C4.81064018,15.75 5.0624995,15.498141 5.0624995,15.1875006 L5.0624995,7.87500003 C5.0624995,7.56435944 4.81064018,7.3125 4.49999975,7.3125 C4.18935932,7.3125 3.9375,7.56435944 3.9375,7.87500003 L3.9375,15.1875006 C3.9375,15.498141 4.1893239,15.75 4.49999975,15.75 L4.49999975,15.75 Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.f80c4d45309c23dbea6daac621ec99a4.svg";
export { ForwardRef as ReactComponent };